<template>
  <div class="main_center" style="margin: 0 0;padding-top: 8px;">
    <div class="content" style="padding: 16px 16px 5px 16px;">
      <el-form ref="form" :model="form" label-width="100px">
        <el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="年份：">
                <el-select v-model="form.year" value-key="value" style="width: 100%" @change="yearsChange">
                  <el-option v-for="(item, index) in yearsList" :key="index" :label="item" :value="item"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
              <el-col :span="6">
                  <el-form-item label="业务类型：">
                      <el-select v-model="businessType" value-key="value" style="width: 100%" @change="searchBtn">
                          <el-option v-for="(item, index) in businessTypeNamelist"
                                     :key="index"
                                     :label="item.name"
                                     :value="item.value">
                          </el-option>
                      </el-select>
                  </el-form-item>
              </el-col>
            <el-col :span="6">
              <el-form-item label="关键字：" props="searchKey">
                <el-input v-model="form.searchKey" clearable placeholder="请输入项目编号，项目名称关键字" @keyup.enter.native="searchBtn"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="">
                <div>
                  <el-button plain size="small" type="primary" @click="reflash">重置</el-button>
                  <el-button size="small" type="primary" @click="searchBtn">搜索</el-button>
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <!-- <el-row :gutter="20">
          <el-col :span="10" :offset="6">
            <el-form-item label=" ">
              <el-input v-model="form.searchKey" placeholder="请输入项目编号，项目名称关键字" clearable @keyup.enter.native="searchBtn">
                <el-button slot="append" type="primary" size="mini" icon="el-icon-search" @click.stop="searchBtn">搜索</el-button>
              </el-input>
            </el-form-item>
            <input hidden />
          </el-col>
        </el-row> -->
        <!-- <el-row>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="年份：">
                                <el-select v-model="form.year" value-key="value" style="width:100%;" @change="yearsChange">
                                    <el-option v-for="(item, index) in yearsList" :key="index" :label="item"
                                        :value="item"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>

                        <el-col :span="8">
                            <el-form-item label="编号：" props="businessCode">
                                <el-input v-model="form.businessCode" clearable placeholder="请输入内容搜索"
                                    @keyup.enter.native="seachBtn"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" v-if="moreSearchItem">
                            <el-form-item label="名称：" props="businessName">
                                <el-input v-model="form.businessName" clearable placeholder="请输入内容搜索"
                                    @keyup.enter.native="seachBtn"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" v-if="!moreSearchItem">
                            <el-form-item label="">
                                <div>
                                    <el-button plain size="small" type="primary" @click="reflash">重置</el-button>
                                    <el-button size="small" type="primary" @click="seachBtn">搜索</el-button>
                                    <el-button size="mini" type="text" v-if="!moreSearchItem"
                                        @click="moreSearchItem = true">| 展开</el-button>
                                    <el-button size="mini" type="text" v-if="moreSearchItem"
                                        @click="moreSearchItem = false">| 收起</el-button>
                                </div>
                            </el-form-item>
                        </el-col>

                    </el-row>
                    <el-col :span="8" v-if="moreSearchItem">
                        <el-form-item label="见证环节：" props="flowName">
                            <el-input v-model="form.flowName" clearable @keydown.enter.native.stop="getDataList"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-row>
                        <el-col :span="8" v-if="moreSearchItem">
                            <el-form-item label="见证方式：" props="witnessMod">
                                <el-select v-model="form.witnessMod" clearable value-key="value" style="width:100%;"
                                    @change="seachBtn">
                                    <el-option label="全部" value="-1"></el-option>
                                    <el-option v-for="(item, index) in witnessModlist" :key="index" :label="item.name"
                                        :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" v-if="moreSearchItem">
                            <el-form-item label="见证状态：" props="witnessStatus">
                                <el-select v-model="form.witnessStatus" clearable value-key="value" style="width:100%;"
                                    @change="seachBtn">
                                    <el-option label="全部" value="-1"></el-option>
                                    <el-option v-for="(item, index) in witnessStatuslist" :key="index" :label="item.name"
                                        :value="item.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>

                    </el-row>
                    <el-row>
                        <el-col :span="8" v-if="moreSearchItem">
                            <el-form-item label="交易中心：">
                                <el-select v-model="form.tradeId" clearable value-key="value" style="width:100%;"
                                    @change="seachBtn">
                                    <el-option label="全部" value=""></el-option>
                                    <el-option v-for="(item, index) in transactionCenterList" :key="index"
                                        :label="item.orgName" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" v-if="moreSearchItem">
                            <el-form-item label="项目关注度：" prop="importantPrj">
                                <el-radio :label=-1 v-model="form.importantPrj">全部项目</el-radio>
                                <el-radio :label=1 v-model="form.importantPrj">重点关注项目</el-radio>
                                <el-radio :label=0 v-model="form.importantPrj">非重点关注项目</el-radio>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" v-if="moreSearchItem">
                            <el-form-item label="">
                                <div>
                                    <el-button plain size="small" type="primary" @click="reflash">重置</el-button>
                                    <el-button size="small" type="primary" @click="seachBtn">搜索</el-button>
                                    <el-button size="mini" type="text" v-if="!moreSearchItem"
                                        @click="moreSearchItem = true">| 展开</el-button>
                                    <el-button size="mini" type="text" v-if="moreSearchItem"
                                        @click="moreSearchItem = false">| 收起</el-button>
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>

                </el-row> -->
      </el-form>

      <space :left="-16" :right="-16" :bottom="16" />

      <el-table :data="tableData" v-loading="dataListLoading" ref="expertExtractTable" :height="tableMaxHeight" stripe border>
        <el-table-column
          fixed
          label="序号"
          type="index"
          :index="indexMethod"
          width="50"
          align="center"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column label="省库抽取以及通知状态" align="left" width="170px" fixed="right">
          <template slot-scope="scope">
            <tags v-if="scope.row.informState" :status="scope.row.informState" />
          </template>
        </el-table-column>
        <el-table-column label="操作" align="left" width="150px" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" title="见证" @click="router(scope.row)">{{
              scope.row.witnessStatus == "1" ? "见证" : "查看"
            }}</el-button>
            <el-button type="text" size="small" @click="extractRouter(scope.row)">进省库抽取</el-button>
          </template>
        </el-table-column>

        <el-table-column label="抽取受理状态" prop="applyState" align="left" width="120" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <!-- 申请1待申请2待授权3已授权4已拒绝 -->
            <!-- <span :class="['mlink', scope.row.applyState == '1' ? 'warning' : scope.row.applyState == '2' ? 'success' : 'danger']">
                            <span :class="['dot', scope.row.applyState == '1' ? 'warning' : scope.row.applyState == '2' ? 'success' : 'danger']"></span>{{scope.row.applyState}}
                        </span> -->
            <applyStatus :status="scope.row.witnessStatus" mapName="tag" />
          </template>
        </el-table-column>

        <el-table-column label="招标项目编号/标段编号" prop="tradePlatfCode" align="left" width="200" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="招标项目名称/标段名称" prop="businessName" align="left" width="400" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="所属交易中心" prop="tradeName" align="left" width="200" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <el-tag>{{ scope.row.tradeName }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="专家库" prop="expertLibName" align="left" width="150" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ "湖北省专家库" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="专家报到(签到)时间" prop="partTime" align="left" width="200" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="专家报到地点" prop="partAddress" align="left" width="200" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="提交人" prop="processinstancecreator" align="left" width="200" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column label="提交时间" prop="processinstancecreatedate" align="left" width="200" :show-overflow-tooltip="true"></el-table-column>
      </el-table>
      <pagination
        class="limit"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        :page.sync="pageIndex"
        :limit.sync="pageSize"
        @pagination="paginationChange"
      >
      </pagination>
    </div>
  </div>
</template>

<script>
import space from "../../common/components/space.vue";
import Pagination from "@/components/Pagination";
import { nearSixYearsList } from "@/utils/index";
import tags from "./components/tags.vue";
import applyStatus from "./components/applyStatus.vue";

export default {
  name: "expertExtractList",
  components: {
    space,
    Pagination,
    tags,
    applyStatus,
  },
  data() {
    return {
      form: {
        year: new Date().getFullYear(),
        businessCode: "",
        businessName: "",
        witnessMod: "-1",
        witnessStatus: "-1",
        importantPrj: -1,
        flowName: "",
        tradeId: "", // 交易中心ID
        searchKey: "",
      },
      businessType: "GC",
      moreSearchItem: false,
      yearsList: [],
      tableData: [],
      pageIndex: 1,
      pageSize: 12,
      total: 0,
      dataListLoading: false,
      tableMaxHeight: document.documentElement.clientHeight - 275,
      sortParams: {
        prop: '',
        order: ''
      },
        businessTypeNamelist: [], // 业务类型选择列表
    };
  },
  methods: {
      getDic(type) { // 获取字典
          this.$http.get('/sys/dictData/getList?type=' + type).then(res => {
              if (res.data.code === '1') {
                  switch (type) {
                      case 'jz_dgwitness_bustype': this.businessTypeNamelist = res.data.data; break;
                  }
              }
          })
      },
    ifmove() {
      // let hasBtnPermisson = this.hasBtnPermission('btn_jz_buswitness_'+this.businessType+'del');
      const hasBtnPermisson = false;
      let tableMaxHeight = document.documentElement.clientHeight - 353 + (hasBtnPermisson ? 0 : 41);
      this.pageSize = parseInt((tableMaxHeight) / 50) || 1;
      this.$nextTick(() => {
        this.tableMaxHeight = tableMaxHeight;
      });
    },
    searchBtn() {
      this.pageIndex = 1;
      this.getList();
    },
    reflash() {
      this.form = {
        year: new Date().getFullYear(),
        searchKey: "",
        businessCode: "",
        businessName: "",
        witnessMod: "-1",
        witnessStatus: "-1",
        importantPrj: -1,
        flowName: "",
        tradeId: "", // 交易中心ID
      };
      this.pageIndex = 1;
      this.getList();
    },
    yearsChange(val) {
      this.yearsList = nearSixYearsList(val);
      this.getList();
    },
    getList() {
      this.$http
        .post(`/businessFlowWitness/expertList`, {
          page: this.pageIndex,
          rows: this.pageSize,
          searchKey: this.form.searchKey,
          orderBy: this.sortParams.prop && this.sortParams.order ? this.sortParams.prop+(this.sortParams.order == "ascending" ? " asc" : " desc"):'',
          filter: {
            auditYear: this.form.year,
            // witnessMod: this.form.witnessMod == "-1" ? "" : this.form.witnessMod,
            // importantPrj: this.form.importantPrj == -1 ? "" : this.form.importantPrj,
            // witnessStatus: '',
            // businessName: this.form.businessName,
            // businessCode: this.form.businessCode,
            businessType: this.businessType,
            // flowName: this.form.flowName,
            // tradeId: this.form.tradeId
          },
        })
        .then((res) => {
          this.tableData = res.data.rows;
          this.total = res.data.total;
        });
    },
    sortChange({ column, prop, order }) { //排序
      this.sortParams.prop = prop || column.prop;
      this.sortParams.order = order || column.order;
      this.getList();
    },
    paginationChange({ page, limit }) {
      this.pageIndex = page;
      this.pageSize = limit;
      this.getList();
    },
    indexMethod(index) {
      return (this.pageIndex - 1) * this.pageSize + index + 1;
    },
    router(item) {
      this.$router.push({
        name: "busWitness_detail",
        query: {
          businessType: this.businessType,
          id: item.id,
          purchaserMode: item.purchaserMode || "",
          evalcommitteeBuildId: item.evalcommitteeBuildId,
          tenderCode: item.businessCode,
        },
      });
    },
    extractRouter(row) {
      window.open("https://183.95.190.180:82/TPFrame/customframe4bid/login_TP");
    },
    routerSign(row) {
      this.$router.push({
        name: "expertExtract_detail",
        query: {
          businessType: row.businessType,
        },
      });
    },
  },
  activated() {
    this.getList();
  },
  mounted() {
    // this.getList();
    this.yearsList = nearSixYearsList(this.form.year);
      this.getDic('jz_dgwitness_bustype');
    this.ifmove();
    let resizeTag = true;
    let that = this;
    window.onresize = () => {
      if (resizeTag) {
        //防抖动
        that.ifmove();
        resizeTag = false;
        setTimeout(() => {
          resizeTag = true;
        }, 1000);
      }
    };
  },
};
</script>


<style lang="less" scoped>
::v-deep .main_center .content {
  padding:  10px 10px 0 10px !important;
}
</style>
